import { BaseAuthenticatedView, DefaultView } from '@/views/authenticated';
import { DistrictSelectView } from '@/views/authenticated';

import authRoutes from './auth';
import categoryRoutes from './categories';
import districtRoutes from './districts';
import frameworkRoutes from './frameworks';
import planRoutes from './plans';
import provinceRoutes from './provinces';
import revisionRoutes from './revisions';
import userRoutes from './users';
import settingRoutes from './settings';

export default [
  {
    name: 'app_base_authenticated',
    component: BaseAuthenticatedView,
    meta: { requiresAuthentication: true, redirectAuthenticatedUsers: false },
    children: [
      {
        path: '/',
        name: 'app_default',
        meta: { redirectAuthenticatedUsers: false, requiresAuthentication: true },
        component: DefaultView,
      },
      {
        path: '/select-district',
        name: 'app_district_select',
        meta: { title: 'Select District', requiresAuthentication: true },
        component: DistrictSelectView,
      },
      ...planRoutes,
      ...provinceRoutes,
      ...districtRoutes,
      ...settingRoutes,
      ...frameworkRoutes,
      ...categoryRoutes,
      ...userRoutes,
      ...revisionRoutes,
      ...authRoutes,
    ],
  },
];
